var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconOcclusogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wasm-occlusogram-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.01,
    y: 8.01,
    width: 47.98,
    height: 47.98
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wasm-occlusogram-clippath)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m34.97,39.16c3.26,0,5.92,2.66,5.92,5.92,0,2.67-2.8,13.4-4.48,19.82-.74,2.82-1.37,5.25-1.82,7.11-.04.18-.17.32-.28.32-.02,0-.04,0-.06,0-.04,0-.18-.17-.18-.4v-5.28c0-3.43-2.79-6.23-6.23-6.23s-6.23,2.92-6.23,6.79v4.72c0,.23-.14.38-.18.39-.02,0-.05,0-.07,0-.12,0-.24-.13-.28-.3-.44-1.85-1.07-4.33-1.79-7.2-1.55-6.1-4.43-17.46-4.43-19.74,0-3.26,2.66-5.92,5.92-5.92.81,0,1.6.16,2.33.48,1.51.65,3.11.98,4.76.98s3.26-.33,4.76-.98c.74-.32,1.52-.48,2.33-.48m0-4c-1.39,0-2.71.29-3.91.8-1.01.43-2.09.65-3.18.65s-2.17-.22-3.18-.65c-1.2-.52-2.52-.8-3.91-.8-5.48,0-9.92,4.44-9.92,9.92,0,3.77,4.68,20.91,6.33,27.86.46,1.96,2.17,3.38,4.17,3.38.26,0,.53-.02.8-.07,2.04-.38,3.45-2.25,3.45-4.32v-4.72c0-1.8,1-2.79,2.23-2.79s2.23,1,2.23,2.23v5.28c0,2.07,1.42,3.95,3.46,4.33.27.05.53.07.79.07,2,0,3.7-1.42,4.17-3.38,1.67-6.95,6.41-23.55,6.41-27.86,0-5.48-4.44-9.92-9.92-9.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m42.64-6.89c.12,0,.24.13.28.3.44,1.85,1.07,4.33,1.79,7.2,1.55,6.1,4.43,17.46,4.43,19.74,0,3.26-2.66,5.92-5.92,5.92-.81,0-1.6-.16-2.33-.48-1.51-.65-3.11-.98-4.76-.98s-3.26.33-4.76.98c-.74.32-1.52.48-2.33.48-3.26,0-5.92-2.66-5.92-5.92,0-2.67,2.8-13.4,4.48-19.82.74-2.82,1.37-5.25,1.82-7.11.04-.18.17-.32.28-.32.02,0,.04,0,.06,0,.04,0,.18.17.18.4V-1.21c0,3.43,2.79,6.23,6.23,6.23s6.23-2.92,6.23-6.79v-4.72c0-.23.14-.38.18-.39.02,0,.05,0,.07,0m0-4c-.26,0-.53.02-.8.07-2.04.38-3.45,2.25-3.45,4.32V-1.77c0,1.8-1,2.79-2.23,2.79h0c-1.23,0-2.23-1-2.23-2.23v-5.28c0-2.07-1.42-3.95-3.46-4.33-.27-.05-.53-.07-.79-.07-2,0-3.7,1.42-4.17,3.38-1.67,6.95-6.41,23.55-6.41,27.86,0,5.48,4.44,9.92,9.92,9.92,1.39,0,2.71-.29,3.91-.8,1.01-.43,2.09-.65,3.18-.65s2.17.22,3.18.65c1.2.52,2.52.8,3.91.8,5.48,0,9.92-4.44,9.92-9.92,0-3.77-4.68-20.91-6.33-27.86-.46-1.96-2.17-3.38-4.17-3.38h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 47.29,
    y1: 38.03,
    x2: 51.92,
    y2: 42.66,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 49.31,
    y1: 33.44,
    x2: 54.7,
    y2: 33.44,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 17.41,
    y1: 27.41,
    x2: 12.78,
    y2: 22.78,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 15.4,
    y1: 32,
    x2: 10,
    y2: 32,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconOcclusogram);
export default __webpack_public_path__ + "static/media/SDS_icon_Occlusogram.07c0ad67da8c8009747db71702977120.svg";
export { ForwardRef as ReactComponent };